import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiClient, extractApiError } from '../api/axios';
import { API } from '../constants/api';

const initialState = {
  loading: false,
  error: '',
  success: false,
  authData: null,
  username: '',
  password: '',
  role: '',
  token: null,
  isAuthenticated: false,
};

export const authAdmin = createAsyncThunk('auth/authAdmin', async (authData, { rejectWithValue }) => {
  try {
    const response = await apiClient.post(API.auth.login, authData);
    return response.data;
  } catch (error) {
    if (error.code === 'ERR_BAD_RESPONSE') {
      return rejectWithValue('Ushbu foydalanuvchi tizimda mavjud emas');
    }
    return rejectWithValue(error?.response?.data?.detail?.[0] || extractApiError(error));
  }
});

export const updateToken = createAsyncThunk('auth/updateToken', async (token, { rejectWithValue }) => {
  try {
    const response = await apiClient.post(API.auth.updateToken, { token });
    return response.data;
  } catch (error) {
    return rejectWithValue(
      error?.response?.data?.detail?.[0] || extractApiError(error) || 'Token yangilashda xatolik yuz berdi'
    );
  }
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUsername: (state, { payload }) => {
      state.username = payload;
    },
    setPassword: (state, { payload }) => {
      state.password = payload;
    },
    setRole: (state, { payload }) => {
      state.role = payload;
    },
    setDefault: (state) => {
      state.error = '';
      state.success = false;
      state.loading = false;
    },
    logout: (state) => {
      state.authData = null;
      state.token = null;
      state.role = '';
      state.isAuthenticated = false;
      state.username = '';
      state.password = '';
    },
    setToken: (state, { payload }) => {
      state.token = payload;
      state.isAuthenticated = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(authAdmin.pending, (state) => {
        state.loading = true;
        state.error = '';
        state.success = false;
      })
      .addCase(authAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.authData = action.payload;
        state.token = action.payload.token;
        state.role = action.payload.role;
        state.isAuthenticated = true;
        state.success = true;
        state.password = '';
        toast.success('Muvaffaqiyatli kirildi');
      })
      .addCase(authAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        state.isAuthenticated = false;
        toast.error(action.payload);
      })
      .addCase(updateToken.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { setUsername, setPassword, setRole, setDefault, logout, setToken } = authSlice.actions;

export default authSlice.reducer;
